import React from 'react'
import ReactDOM from 'react-dom'
import WidgetApp from 'WidgetApp'
import SimpleCtaApp from './App'

ReactDOM.render(
  <WidgetApp>
    <SimpleCtaApp />
  </WidgetApp>,
  document.getElementById('root'),
)
